import '~entrypoints/tailwind';
import '~packs/purchase/images';
import '~packs/purchase/css';
import '~packs/css/components/pn-button.css';
import '~packs/css/components/pn-checkbox.css';
import '~packs/css/components/pn-input.css';
import '~packs/css/alpine.css';

import { analytics, getSessionId } from '~entrypoints/analytics';
import stripePaymentForm from '~packs/purchase/src/stripe-payment-form';
import stripe3dsForm from '~packs/purchase/src/stripe-3ds-form';
import paypalWidget from '~packs/purchase/src/paypal-widget';
import Storage from '~packs/purchase/src/storage';
import Alpine from 'alpinejs';
import persist from '@alpinejs/persist';

const distinctId = getSessionId();

// NOTE: Set to window to provide access to Alpine components in template
window.$storage = new Storage(window.location.pathname);

const email = window.$storage.email;

window.analytics = analytics;

analytics.identify(distinctId, { email });

if (pnEnv.RAILS_ENV !== 'production') {
  window.Alpine = Alpine; // NOTE: Used to aid in debugging
}

Alpine.plugin(persist);

Alpine.store('sessionId', distinctId);

Alpine.data('stripePaymentForm', stripePaymentForm);
Alpine.data('stripe3dsForm', stripe3dsForm);
Alpine.data('paypalWidget', paypalWidget);

Alpine.start();
